export const playersTypes = {
    LOAD_PLAYERS : 'LOAD_PLAYERS_PLAYERS',
    ADD_PLAYERS : 'ADD_PLAYERS_PLAYERS',
    SET_ONLINE : 'SET_ONLINE_PLAYERS',
    SET_OFFLINE : 'OFFLINE_PLAYERS',
    RESET : 'RESET'
};